<mat-dialog-content>
  <div class="row">
    <img
      src="../../../../../assets/icons/icono.png"
      onerror="this.src = 'assets/img/cantfindimage.jpg'"
      style="margin-left: 1px; width: 20px; height: 20px"
    />
    <div class="col-md-2" style="margin-top: 10px">
      <h2 mat-dialog-tittle>{{ 'New Purchase' | translate }}</h2>
    </div>
  </div>
  <form [formGroup]="purchaseForm">
    <div class="row" style="justify-content: center" id="container-top">
      <div class="col" id="div-responsive">
        <mat-form-field>
          <mat-label>{{ 'Purchase number' | translate }}</mat-label>
          <input
            type="text"
            matInput
            formControlName="written_invoice"
            autocomplete="off"
          />
        </mat-form-field>
      </div>
      <div class="col" id="div-responsive">
        <mat-form-field>
          <mat-label>{{ 'Type provider' | translate }}</mat-label>
          <ng-container formArrayName="itemRows">
            <input
              id="input-top"
              type="text"
              matInput
              [matAutocomplete]="autoProvider"
              [formControl]="newProvider"
            />
          </ng-container>
          <mat-autocomplete
            #autoProvider="matAutocomplete"
            [displayWith]="displayFnProvider"
            (optionSelected)="onProviderSelected($event)"
          >
            @for (provider of providersList; track provider) {
              <mat-option [value]="provider">
                {{ provider.nombre }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      @if (companyObject.countries[0].name === 'Colombia') {
        <div class="col" id="div-responsive">
          <mat-form-field>
            <mat-label>{{ 'Select customer city' | translate }}</mat-label>
            <input
              type="text"
              matInput
              [formControl]="citiesCustomerForm"
              name="city"
              [matAutocomplete]="autoCustomerCity"
            />
            <mat-autocomplete
              #autoCustomerCity="matAutocomplete"
              [displayWith]="displayFnCity"
              (optionSelected)="onCitiesCustomer($event)"
            >
              @for (city of filteredOptionsCustomerCities | async; track city) {
                <mat-option [value]="city">
                  {{ city.name }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      }
      @if (purchaseForm.get('tax_include')?.value === false) {
        <div class="col" id="div-responsive">
          <mat-form-field>
            <mat-label>{{ 'Tax' | translate }} (%)</mat-label>
            <input
              type="number"
              matInput
              formControlName="tax"
              (keyup)="calculation()"
              autocomplete="off"
            />
          </mat-form-field>
        </div>
      }
      <div class="col" id="div-responsive">
        <mat-form-field appearance="fill">
          <mat-label>{{ 'Date' | translate }}</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="date" />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col" id="div-responsive">
        <mat-form-field appearance="fill">
          <mat-label>{{ 'Due Date' | translate }}</mat-label>
          <input matInput [matDatepicker]="picker2" formControlName="dueDate" />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <mat-checkbox (change)="calculation()" formControlName="clause">{{
      'Exclusion Clause' | translate
    }}</mat-checkbox>
    @if (isElectronicInvoicing) {
      <mat-checkbox formControlName="is_electronic_document">{{
        'purchases.electronic-document-check' | translate
      }}</mat-checkbox>
    }
    <mat-checkbox (change)="onDraftChange($event)" formControlName="is_draft">{{
      'purchases.draft-check' | translate
    }}</mat-checkbox>
    <table class="table table-bordered">
      <thead class="thead-dark">
        <tr>
          <th>
            <mat-label>{{ 'Warehouse' | translate }}</mat-label>
          </th>
          <th>
            <mat-label>{{ 'Articles' | translate }}</mat-label>
          </th>
          <th>
            <mat-label>{{ 'Quantities' | translate }}</mat-label>
          </th>
          <th>
            <mat-label>{{ 'Unit' | translate }}</mat-label>
          </th>
          <th>
            <mat-label>{{ 'Factor' | translate }}</mat-label>
          </th>
          <th>
            <mat-label>{{ 'Prices' | translate }}</mat-label>
          </th>
          <th>
            <mat-label>{{ 'Discounts' | translate }}</mat-label>
          </th>
          <th>
            <mat-label>{{ 'Subtotals' | translate }}</mat-label>
          </th>
          <th colspan="2">
            <mat-label>{{ 'Options' | translate }}</mat-label>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container formArrayName="itemRows" class="row">
          @for (itemrow of rowsArr.controls; track itemrow; let i = $index) {
            <ng-container [formGroupName]="i">
              <tr>
                <td data-label="Warehouse" style="width: 160px">
                  <select
                    (ngModelChange)="updateCurrentWareouse($event)"
                    class="form-control"
                    formControlName="warehouse"
                    style="width: 160px"
                  >
                    <option selected value="">
                      {{ 'Select warehouse' | translate }}
                    </option>
                    @for (warehouse of warehouseList; track warehouse) {
                      <option [value]="warehouse.id_almacen">
                        {{ warehouse.nombre }}
                      </option>
                    }
                  </select>
                </td>
                <td
                  data-label="Articles"
                  style="text-align: left; width: 400px"
                >
                  <input
                    type="text"
                    class="form-control"
                    name=""
                    placeholder="{{ 'Type Article' | translate }}"
                    [matAutocomplete]="autoArticle"
                    formControlName="article"
                    style="width: 400px"
                  />
                  <mat-autocomplete
                    #autoArticle="matAutocomplete"
                    [displayWith]="displayFnArticle"
                    (optionSelected)="onArticleChange(i)"
                  >
                    @for (articles of articleList; track articles) {
                      <mat-option [value]="articles">
                        {{ articles.codigo }} - {{ articles.descripcion }} -
                        {{ 'Tax' | translate }} ({{ articles.tax![0].value }})
                      </mat-option>
                    }
                  </mat-autocomplete>
                  @if (
                    itemrow.get('article')?.value?.id_articulo;
                    as articleId
                  ) {
                    <v-one-inventory-article-warning
                      [articleId]="articleId"
                      [articleCode]="
                        itemrow.get('article')?.value?.codigo ?? ''
                      "
                    />
                  }
                </td>
                <td data-label="Quantities">
                  <input
                    class="form-control"
                    placeholder="0"
                    type="text"
                    (keyup)="onUnitOrQuantityChange(i, 'quantity')"
                    formControlName="quantity"
                  />
                  @if (arrayvalid('quantity')) {
                    <span class="form-text text-danger">{{
                      'Quantity must be greater than 0' | translate
                    }}</span>
                  }
                </td>
                <td data-label="Unit" style="width: 150px">
                  <select
                    class="form-control"
                    formControlName="unit"
                    (change)="onUnitOrQuantityChange(i, 'unit')"
                    style="width: 150px"
                  >
                    <option value="">
                      {{ 'Select unit' | translate }}
                    </option>
                    @if (
                      getGroupedUnits(itemrow.value.article).packagingUnits
                        .length > 0
                    ) {
                      <optgroup label="Unidades de Empaque">
                        @for (
                          packUnit of getGroupedUnits(itemrow.value.article)
                            .packagingUnits;
                          track packUnit.unit.id_unit
                        ) {
                          <option [value]="packUnit.unit.id_unit">
                            {{
                              packUnit.code
                                ? packUnit.code + ' x' + packUnit.factor + ' - '
                                : ''
                            }}{{ packUnit.unit.description }}
                          </option>
                        }
                      </optgroup>
                    }
                    @if (
                      getGroupedUnits(itemrow.value.article).otherUnits.length >
                      0
                    ) {
                      <optgroup label="Otras Unidades">
                        @for (
                          unit of getGroupedUnits(itemrow.value.article)
                            .otherUnits;
                          track unit.id_unit
                        ) {
                          <option [value]="unit.id_unit">
                            {{ unit.description }}
                          </option>
                        }
                      </optgroup>
                    }
                  </select>
                </td>
                <td data-label="Factor" style="width: 120px">
                  <input
                    class="form-control"
                    placeholder="1"
                    type="number"
                    step="0.01"
                    min="0.01"
                    (keyup)="onUnitOrQuantityChange(i, 'factor')"
                    formControlName="customFactor"
                    [disabled]="!itemrow.value.isFactorEditable"
                    [class.bg-light]="!itemrow.value.isFactorEditable"
                    style="width: 100px"
                    [attr.title]="
                      itemrow.value.isFactorEditable
                        ? ('Factor manual - Esta conversión no existe en la base de datos'
                          | translate)
                        : itemrow.value.unit ===
                            itemrow.value.article?.unit?.id_unit
                          ? ('Factor = 1 (Unidad base del artículo)'
                            | translate)
                          : itemrow.value.unit ===
                              itemrow.value.article?.id_packaging_unit
                            ? ('Factor del artículo (configurado en maestro)'
                              | translate)
                            : ('Conversión automática de la base de datos'
                              | translate)
                    "
                  />
                  <small class="form-text text-muted">
                    {{ itemrow.value.quantityInBaseUnit | number: '1.0-2' }}
                    {{
                      itemrow.value.article?.unit?.description ||
                        itemrow.value.article?.packagingUnit?.description ||
                        'UN'
                    }}
                  </small>
                </td>
                <td data-label="Prices">
                  <input
                    class="form-control"
                    placeholder="0"
                    type="text"
                    (keyup)="calculation()"
                    formControlName="price"
                    style="width: 100px"
                  />
                  @if (arrayvalid('price')) {
                    <span class="form-text text-danger">{{
                      'Price value must be 1
                                        or higher' | translate
                    }}</span>
                  }
                </td>
                <td data-label="Discounts">
                  <input
                    class="form-control"
                    placeholder="0"
                    type="text"
                    (keyup)="calculation()"
                    formControlName="discount"
                    (keyup.enter)="addNewRow()"
                  />
                </td>
                <td data-label="Subtotals" style="width: 100px">
                  <div style="margin: 5px; text-align: center">
                    {{ itemrow.value.subtotal | currency: 'USD' }}
                  </div>
                </td>
                <td data-label="Add">
                  <button mat-raised-button (click)="addNewRow()">+</button>
                </td>
                <td data-label="Delete">
                  <button mat-raised-button (click)="deleteRow(i)">x</button>
                </td>
              </tr>
            </ng-container>
          }
        </ng-container>
      </tbody>
    </table>
    <br />
    <div class="row">
      <div class="col-md-1">
        <h3>
          <strong>{{ 'Subtotal' | translate }}: </strong
          >{{ totalWithoutTax | currency: 'USD' }}
        </h3>
      </div>
      <div class="col-md-1">
        <h3>
          <strong>{{ 'Tax' | translate }}: </strong
          >{{ totalTax | currency: 'USD' }}
        </h3>
      </div>
      <div class="col-md-1">
        <h3>
          <strong>{{ 'Total' | translate }}: </strong
          >{{ totalPurchase | currency: 'USD' }}
        </h3>
      </div>
      @if (companyObject.countries[0].name === 'Colombia') {
        <div class="col-md-1">
          <h3>
            <strong>{{ 'Withholding Tax' | translate }}: </strong>
            @if (loadingWithholdings) {
              <mat-spinner
                diameter="18"
                strokeWidth="2"
                class="spinner-inline"
              ></mat-spinner>
            } @else {
              {{ withholdingTax | currency: 'USD' }}
            }
          </h3>
        </div>
      }
      @if (companyObject.countries[0].name === 'Colombia') {
        <div class="col-md-1">
          <h3>
            <strong>{{ 'Ica Tax' | translate }}: </strong>
            @if (loadingWithholdings) {
              <mat-spinner
                diameter="18"
                strokeWidth="2"
                class="spinner-inline"
              ></mat-spinner>
            } @else {
              {{ icaTax | currency: 'USD' }}
            }
          </h3>
        </div>
      }
      <div class="col-md-1">
        <h3>
          <strong>{{ 'Total to pay' | translate }}: </strong
          >{{ totalPurchase - icaTax - withholdingTax | currency: 'USD' }}
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-1">
        <button mat-raised-button mat-dialog-close>
          {{ 'Close' | translate }}
        </button>
      </div>
      <div class="col-md-1">
        <button mat-raised-button (click)="register()">
          {{ 'Register' | translate }}
        </button>
      </div>
    </div>
  </form>
</mat-dialog-content>

<ngx-spinner
  type="ball-scale-multiple"
  template="<img src='../../../../../../assets/gif/V1-Insight-Icon-for-gif-2.gif' />"
  bdColor="rgba(51,51,51,0.8)"
>
  <p style="font-size: 20px; color: #ffffff">{{ 'Loading...' | translate }}</p>
</ngx-spinner>
